import React from 'react';
import CheckButton from '../../components/CheckButton';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Answer = {
    name: string;
    value: string;
}

const PsychlngclCheckStress: React.FC = () => {
    const answers: Answer[] = [];
    const goResult = (type: string) => {
        if ("cancel" === type) {
            if(window.confirm("정말 취소 하시겠습니까? '확인' 버튼을 누르면 심리검사목록 페이지로 이동합니다.")) {
                alert("취소되었습니다.");
                window.location.href="/psychlgclCheck/main";
            }
        } else if ("success" === type) {
            if (answers.length < 5) {
                alert("아직 응답하지 않은 문항이 있습니다.");
                return;
            } else {
                let total = 0;
                answers.map((answer) => (
                    total += parseInt(answer.value)
                ));
                let resultCode = '';
                if (0 <= total && total < 9) {
                    resultCode = "001";
                } else if (8 < total && total < 14) {
                    resultCode = "002";
                } else if (total > 13) {
                    resultCode = "003";
                }
                window.location.href=`/psychlgclCheck/stress/result/${resultCode}`;
            }
        }
    }

    const handleRadioChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value, name} = e.target;
        if (answers.length > 0) {
            // name이 존재하면
            if (answers.findIndex((element) => element.name === name) !== -1) {
                answers[answers.findIndex((element) => element.name === name)].value = value;
            } else {
                answers.push({name: name, value: value});    
            }
        } else {
            answers.push({name: name, value: value});
        }
    }
    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className="contents">
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='스트레스 자가진단'
                        />
                        <div className="mobileface testing">
                            <div className="testWrap stress">
                                <h3 className="f18 black">스트레스 자가진단</h3>
                                <div className="visualBox mt23">
                                    <p className="black lh30">
                                        <strong className="f16">지난 1개월 동안의 느낌이나 상태에 대한 질문입니다.</strong>
                                        <br />자신의 감정상태를 가장 잘 표현한다고 생각되는 문항에 체크해 주십시오.
                                    </p>
                                </div>
                                <h4 className="f14 green mt30">스트레스 자가진단 진행 (5문항)</h4>
                                <fieldset>
                                    <ul className="etc_list">
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">1.  살아가는 데 정신적·신체적으로 감당하기 힘들다고 느낀 적이 있습니까?</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="sq1" value="5" onChange={handleRadioChnage}/> 항상 있었다</label>
                                                    <label><input type="radio" name="sq1" value="4" onChange={handleRadioChnage}/> 거의 언제나 있었다</label>
                                                    <label><input type="radio" name="sq1" value="3" onChange={handleRadioChnage}/> 종종 여러 번 있었다</label>
                                                    <label><input type="radio" name="sq1" value="2" onChange={handleRadioChnage}/> 간혹 있었다</label>
                                                    <label><input type="radio" name="sq1" value="1" onChange={handleRadioChnage}/> 전혀 없었다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">2. 자신의 생활신념에 따라 살려고 애쓰다가 좌절을 느낀 적이 있습니까?   </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="sq2" value="5" onChange={handleRadioChnage}/> 항상 있었다</label>
                                                    <label><input type="radio" name="sq2" value="4" onChange={handleRadioChnage}/> 거의 언제나 있었다</label>
                                                    <label><input type="radio" name="sq2" value="3" onChange={handleRadioChnage}/> 종종 여러 번 있었다</label>
                                                    <label><input type="radio" name="sq2" value="2" onChange={handleRadioChnage}/> 간혹 있었다</label>
                                                    <label><input type="radio" name="sq2" value="1" onChange={handleRadioChnage}/> 전혀 없었다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">3. 한 인간으로서 기본적인 요구가 충족되지 않았다고 느낀 적이 있습니까?</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="sq3" value="5" onChange={handleRadioChnage}/> 항상 있었다</label>
                                                    <label><input type="radio" name="sq3" value="4" onChange={handleRadioChnage}/> 거의 언제나 있었다</label>
                                                    <label><input type="radio" name="sq3" value="3" onChange={handleRadioChnage}/> 종종 여러 번 있었다</label>
                                                    <label><input type="radio" name="sq3" value="2" onChange={handleRadioChnage}/> 간혹 있었다</label>
                                                    <label><input type="radio" name="sq3" value="1" onChange={handleRadioChnage}/> 전혀 없었다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">4. 미래에 대해 불확실하게 느끼거나 불안해 한 적이 있습니까? </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="sq4" value="5" onChange={handleRadioChnage}/> 항상 있었다</label>
                                                    <label><input type="radio" name="sq4" value="4" onChange={handleRadioChnage}/> 거의 언제나 있었다</label>
                                                    <label><input type="radio" name="sq4" value="3" onChange={handleRadioChnage}/> 종종 여러 번 있었다</label>
                                                    <label><input type="radio" name="sq4" value="2" onChange={handleRadioChnage}/> 간혹 있었다</label>
                                                    <label><input type="radio" name="sq4" value="1" onChange={handleRadioChnage}/> 전혀 없었다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">5. 할 일이 너무 많아 정말 중요한 일들을 잊은 적이 있습니까?</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="sq5" value="5" onChange={handleRadioChnage}/> 항상 있었다</label>
                                                    <label><input type="radio" name="sq5" value="4" onChange={handleRadioChnage}/> 거의 언제나 있었다</label>
                                                    <label><input type="radio" name="sq5" value="3" onChange={handleRadioChnage}/> 종종 여러 번 있었다</label>
                                                    <label><input type="radio" name="sq5" value="2" onChange={handleRadioChnage}/> 간혹 있었다</label>
                                                    <label><input type="radio" name="sq5" value="1" onChange={handleRadioChnage}/> 전혀 없었다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                    </ul>
                                </fieldset>
                                <CheckButton goResult={goResult}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckStress;